import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Third-party widgets (Ecwid) can emit the benign ResizeObserver loop warning
// and internal query-cancellation noise (CancelledError), which the dev-server
// overlay would otherwise turn into a blocking error screen. Capture phase so
// this runs before the dev client's own error listeners.
const suppressBenignWidgetError = (e) => {
  const msg = e.message || "";
  const name = e.error?.name || "";
  if (msg.startsWith("ResizeObserver loop") || name === "CancelledError" || msg.includes("CancelledError")) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
};
window.addEventListener("error", suppressBenignWidgetError, true);
window.addEventListener("unhandledrejection", (e) => {
  const name = e.reason?.name || "";
  if (name === "CancelledError") {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
}, true);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
